import { Link } from "react-router-dom";
import { Checkbox } from "@/components/ui/checkbox";
import { BUSINESS } from "@/lib/constants";

export const SmsConsent = ({ id, checked, onCheckedChange, testId }) => (
  <div className="flex items-start gap-3 rounded-lg border border-white/10 bg-[#141419] p-4" data-testid={`${testId}-wrapper`}>
    <Checkbox
      id={id}
      data-testid={testId}
      checked={checked}
      onCheckedChange={(val) => onCheckedChange(val === true)}
      className="mt-0.5 h-5 w-5 border-white/20 data-[state=checked]:bg-[#C9A227] data-[state=checked]:text-black"
    />
    <label htmlFor={id} className="cursor-pointer text-[13px] leading-relaxed text-[#B8B2A6]">
      I agree to receive recurring SMS messages from {BUSINESS.name} regarding my consultation,
      appointments, requested educational information, account-related communications, and follow-up.
      Message frequency varies. Message and data rates may apply. Reply STOP to opt out or HELP for
      help. Consent is not a condition of purchase. View our{" "}
      <Link
        to="/privacy-policy"
        data-testid={`${testId}-privacy-link`}
        className="font-medium text-[#D8B54A] underline underline-offset-2 hover:text-[#E4C463]"
      >
        Privacy Policy
      </Link>{" "}
      and{" "}
      <Link
        to="/terms-and-conditions"
        data-testid={`${testId}-terms-link`}
        className="font-medium text-[#D8B54A] underline underline-offset-2 hover:text-[#E4C463]"
      >
        Terms &amp; Conditions
      </Link>
      .
    </label>
  </div>
);
